export default {
  'm': {
    'uploading': 'Carregando...',
    'upload_failed': 'Falha no upload',
    'EnterID': 'Clique para digitar o BuzzCast ID',
    'select-specifications': 'Clique para selecionar as especificações de recarga',
    'check-account': 'Verifique a conta de recarga',
    'whatID': 'O que é o BuzzCast ID?',
    'getID': 'Digite o BuzzCast ID',
    'maskgetID': 'Digite o BuzzCast ID',
    'toastTips-format-error': 'Formato de entrada está incorreto',
    'toastTips-no-exist': 'O ID não existe',
    'toastTipsPlease': 'Verifique a conta recarregada primeiro',
    'common-problem': 'Problema comum',
    'transaction-succeeded': 'Transação foi bem sucedida',
    'transaction-failed': 'Falha na transação',
    'transaction-cancel': 'Transação foi cancelada',
    'whether-account': '1.Depois de recarregar, como posso verificar se chegou?',
    'answer-whether-account': 'Após a recarga, você pode voltar para [Meu] - [Carteira] do aplicativo para visualizar os diamantes.',
    'no-account': '2.Após a recarga, o que devo fazer se não chegar?',
    'answer-no-account': 'Envie suas perguntas em [Mensagem] - [Notícias oficiais] - [Comentários e ajuda] do aplicativo e forneça as seguintes informações, nosso serviço ao cliente irá ajudá-lo.',
    'recharge-money': '1. Valor da recarga e ID da conta',
    'recharge-time': '2. Data e hora da recarga',
    'recharge-shot': '3. Captura de tela do pagamento bem-sucedido "',
    'recharge-wrong': '3.O que devo fazer se cobrar a conta errada e cobrar a quantia errada.',
    'answer-recharge-wrong': 'Antes de inserir a senha de pagamento, por favor certifique-se de confirmar cuidadosamente o ID da conta de recarga e as informações sobre o valor da recarga antes de fazer uma compra.',
    'refund': '4.Reembolso',
    'answer-refund': 'Desculpe! O BuzzCast atualmente não oferece suporte a nenhuma forma de reembolso.',
    'buy-enter-link': 'Os diamantes de compra podem ser recarregados através do link <a class="web-link" href="https://pay.buzzcast.info">https://pay.buzzcast.info</a>, copie o link e abra-o no seu navegador móvel, vá para a página de compra, verifique o número da conta, selecione as especificações correspondentes e use o método de pagamento apropriado para pagar ~ muitos descontos!',
    'buy-notice-a': 'Nota:<a>{msg}</a> é o único site oficial de compra de diamantes do BuzzCast.',
    'replace': 'Substituir',
    'sureBtn': 'OK',
    'pay-style': 'Escolher método de pagamento',
    'goBack': 'Voltar a página inicial',
    'toastTips': 'Digite o BuzzCast ID',
    'rechargeFAQ_title': 'Problema comum',
    'PayStatusSuccess_title': 'Transação foi bem sucedida',
    'PayStatusFail_title': 'Falha na transação',
    'PayStatusCancel_title': 'Transação foi cancelada',
    'Diamonds_title': 'Site oficial de recarga do diamante de {msg}',
    'buy-notice': 'Nota O pay.buzzcast.info é o único site oficial de compra de diamantes do BuzzCast. Para consultas sobre atendimento ao cliente, digite [Mensagem] - [Notícias oficiais] - [Comentários e ajuda]',
    'RechargeHelp_title': 'Ajuda de recarregar',
    'feedback_and_help': 'Feedback e ajudas',
    'problem_screenshot': 'Captura de tela/gravação da pergunta ({msg})',
    'problem_description': 'Descrição da pergunta',
    'problem_description_placeholder': 'Por favor, descreva o problema que você está enfrentando',
    'optional': 'opcional',
    'required': 'obrigatório',
    'openAPP': 'Open BuzzCast APP',
    'buy-diamonds-tit': 'Comprar serviços de diamantes',
    'description': 'Único site oficial de recarga de diamantes do BuzzCast, o BuzzCast é um software social internacional, usuários de mais de 150 países e regiões do mundo estão usando o BuzzCast',
    'keywords': 'Recarga do BuzzCast, recarga de diamante do BuzzCast, recarga oficial do BuzzCast, site oficial de recarga do BuzzCast',
    'payforType': 'Método de recarga',
    'trueText': 'OK',
    'falseText': 'Abolir',
    'alertShowTxt1': 'Tem certeza de que usará',
    'alertShowTxt3': 'para recarregar',
    'alertShowTxt5': 'diamantes?',

    'EnterIDTip': 'Recarga rápida {msg}',

    'scanLogin': 'Para privacidade e segurança da conta, por favor, digitalize o código para fazer o login',
    'scanTip': 'Dica: Clique em Swipe" no canto superior direito do BuzzCast "Personal Center/Data".',
    'scanVersion': 'Passe o código para fazer o login, e também suporte o reconhecimento da captura de tela do código QR para fazer o login"',
    'delAccount': 'Excluir conta',
    'logout': 'Sair',

    'submit': 'Enviar',
    'email_place_holder': 'Digite sua caixa postal',
    'fill_in_email_address': 'Favor preencher seu endereço de e-mail',
    'fill_in_all_required': 'Favor inserir uma descrição do problema',
    'order_exception_notice': 'Dica: Você deve fornecer um número de pedido ou um screenshot de sua conta para pedidos de recarga incomuns',
    'cannot_read_file': 'Não é possível ler o arquivo',
    'submitting': 'Enviando...',
    'submit_failed': 'Falha no envio',
    'contact_email': 'E-mail de contato',
    'provide_email': 'Favor fornecer seu endereço de e-mail para receber notificações de pagamento',
    'email_address': 'Endereço de e-mail',


    'sel_country_area': 'Selecione o país ou região',
    'search_for': 'Pesquisar',
    'login': 'Conecte-se',
    'scan_login': 'Passe o código para fazer o login',
    'account_password_error': 'Número de telefone ou senha incorreta',
    'user_frozen': 'O usuário foi congelado',
    'account_no_reg': 'Conta não registrada',
    'login_no': 'Não está logado',
    'login_after_recharge': 'Login para recarregar',
    'scan_login_lesson': 'Tutorial sobre como passar o código para fazer o login',
    'scan_login_desc': 'O método de login de varredura permite o login rápido e seguro de recarga do site.A seguir, explicaremos como fazer um login de deslize em cada uma das duas formas.',
    'scan_login_a_title': 'Login através do reconhecimento da captura de tela do código QR',
    'scan_login_a_p1': '1. Mais adequado para o cenário de uso de um único dispositivo, os usuários entram na página de login do site de recarga, clicam e selecionam "Scan Code Login", uma captura de tela da página com o código QR de login será exibida e salva no álbum. (A função de captura de tela varia ligeiramente de dispositivo para dispositivo, favor procurar as instruções de operação da função de captura de tela)',
    'scan_login_a_p2': '2. Abra BuzzCast APP, você pode clicar em "Swipe" no canto superior direito do módulo de função "Personal Center" ou "Dynamic" para entrar no módulo de função de digitalização de código.',
    'scan_login_a_p3': '3. Clique em "Album Selection" e permita a permissão do álbum, selecione a captura de tela salva da página de login do código QR, clique no botão de confirmação "Login" após o reconhecimento do sistema, corte para o navegador e aguarde um pouco, a página carregará automaticamente as informações do usuário.',
    'scan_login_b_title': 'Login através da leitura do código QR',
    'scan_login_b_p1': '1. Mais adequado para múltiplos dispositivos, os usuários entram na página de login do site de recarga, clique para selecionar "sweep code login".',
    'scan_login_b_p2': '2. Abra o BuzzCast APP em outro dispositivo, você pode entrar no módulo de função "Personal Center" ou "Dynamic" clicando em "Swipe" no canto superior direito.',
    'scan_login_b_p3': '3. Direcionou a caixa de digitalização para o código QR da página de login de digitalização e clicou no botão "Login" após o reconhecimento do sistema (recomenda-se manter uma certa distância entre os dispositivos durante a digitalização para facilitar a identificação do sistema). Após uma breve espera, a página carregará automaticamente as informações do usuário.',
    'scan_login_lesson_end': 'O acima é para fazer a varredura do guia do tutorial de login do código, espero ajudá-lo. Para consulta de atendimento ao cliente, digite a mensagem do terminal do APP - notícias oficiais - feedback e ajuda.',
    'or': 'Ou',
    'input_phone_num': 'Por favor, digite o seu número de telefone celular',
    'input_email': 'Por favor insira o endereço de email',
    'input_password': 'Digite a senha',
    'log_in_using_Facebook': 'Login com Facebook',
    'log_in_using_Google': 'Login com Google',
    'account_or_pwd_error': 'Conta ou senha incorreta',
    'pay_fail_system_risk': 'Transaction failed: system abnormal',
    'recharge_fail_risk_network': 'A recarga falhou. Você pode estar em um ambiente de rede de alto risco ou por outros motivos. Se precisar de ajuda com a recarga, relate o seu problema para nós.',
    'friendly_tip': 'Dicas amigáveis',
    'i_got_it': 'Entendi',
    'android_fblogin_tip': 'Como o Facebook não oferece mais suporte para login de autenticação no navegador integrado do Android, talvez você não consiga fazer login ao fazer login desta forma. Se você encontrar esse tipo de problema de login, use o navegador Chrome para acessá-lo.',
    'recharge_tip': 'O número final de diamantes recebidos é baseado no valor real da recarga',
    'charge': 'Recarregar',
    'link_add_mainpage': 'Adicione o link para a tela inicial pela próxima recarga',
    'click_me_to_add': 'Clique-me para adicionar',
    'user_has_delete': 'Esta conta foi cancelada',
    'support_contant_whatsapp': 'Se precisar de suporte, entre em contato com o atendimento ao cliente no {msg} App：1924383',
    'buy_balance': 'Saldo disponível:',
    'official_coin_seller': 'Comerciante oficial de moedas',
    'paystyle_unavailabel_change_other': 'O sistema está anormal, este método de pagamento está temporariamente indisponível, você pode mudar para outros métodos de pagamento.',
    'failedPay': 'O pagamento encontrou um problema, por favor, faça um novo pagamento',
    "copied": "Copiado",
    "reseller": "Revendedor",
    "netword_busy_try": "A rede está ocupada, tente novamente",
    "placecommen": 'Digite as palavras de pesquisa',
    "app_all_v2": 'Tudo',

		"use_phone_login": `Tocar com telefone`,
    "use_email_login": `Tocar com e-mail`,
    "device_is_more": "O número de contas registradas para este dispositivo atingiu o limite máximo",
    "Operation_failed": "Este dispositivo foi permanentemente congelado devido a violações da conta",
    "connection_fail_retry_feedback": "Falha na conexão. Certifique-se de que a rede está estável e tente novamente. Se ainda encontrar erros, relate-os para nós, e nós os resolveremos o mais rápido possível.",
    "fawry_recharge_failed": "A recarga de ${msg} via {method} não foi bem-sucedida.",
    "feedback": "Feedback",
    "problem_feedback": "Comentarios",
    "recommended_recharge_methods": "Métodos de pagamento recomendados",
    "try_recharge_methods": "Por favor, tente recarregar usando os seguintes métodos. Se ainda encontrar problemas, clique no botão \"{feedback}\" abaixo para entrar em contato conosco.",
    "unable_recharge": "Não é possível recarregar",
    "submitted_successfully": "Apresentado com sucesso",
    "feedback_success_tip": "Obrigado pelo seu feedback, trataremos do assunto o mais rápido possível, dentro de 24 horas.",
    "completed": "Completo",
    'contact_information': 'Detalhes de contato (opcional)',
    'pay_failed': 'Pagamento falhou',
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/pt.js